<div *ngIf="showNavbar">
  <app-main-nav>
    <router-outlet></router-outlet>
  </app-main-nav>
</div>

<div *ngIf="!showNavbar">
  <router-outlet></router-outlet>
</div>